import React, { createContext, useState, useContext } from 'react'

export const UserContext = createContext();

export const useUser = ()=> useContext(UserContext);

export const UserProvider = ({ children }) => {

    const initUser = {
            pmKeys: null,
            callsign: null,
            firstName: null,
            lastName: null,
            isLoggedIn: false,
            preferences: {
                theme: 'light',
                notifications: true,
            },
            isComplete(){
                return (this.pmKeys != null && this.pmKeys != '' && this.callsign != null && this.callsign != '' && this.firstName != null && this.firstName != '' && this.lastName != null && this.lastName != '');
            }
    }

    const [userData, setUserData] = useState(initUser);

    const value = { userData, setUserData };
    return <UserContext.Provider value={value}>{children}</UserContext.Provider>
}